<template>
  <dialog class="VideoDialog" @close="markClosed">
    <div class="closeButtonShelf">
      <CloseButton @click="close" class="closeButton" />
    </div>
    <div v-if="isOpen && content">
      <MuxVideo
        :video="content.video"
        :posterImage="content.posterImage"
        autoplay
        controls
        class="video"
      />
    </div>
  </dialog>
</template>

<script>
import CloseButton from '~/vue-components/shared/CloseButton.vue'
import MuxVideo from '../../elems/MuxVideo.vue'

export default {
  components: {
    CloseButton,
    MuxVideo,
  },
  props: {
    content: Object,
  },
  data() {
    return {
      isOpen: false,
    };
  },
  methods: {
    // NOTE: The showVideo() method is called by the parent component
    showVideo() {
      this.$el.showModal();
      this.isOpen = true;
    },
    markClosed() {
      this.isOpen = false;
    },
    close() {
      this.$el.close();
    },
  },
}
</script>

<style scoped>
/* Reset styles */
dialog {
  border-style: none;
  padding: 0;
  background-color: transparent;
}

.VideoDialog {
  max-width: 95%;
}

.VideoDialog::backdrop {
  background-color: rgba(0, 0, 0, 0.75);
}

.closeButtonShelf {
  display: flex;
  justify-content: flex-end;
  padding: var(--spacing-2);
}

.closeButton {
  --main-color: var(--text-color-white);
}

.closeButton:focus {
  color: #ddd;
  outline: none;
}

.video {
  width: 60rem;
  max-width: 100%;
}
</style>
